App.factory('UserExtensionStats', ['restmod', restmod => {
    return restmod.model('/user_extension_stats')
}])
